import {combineReducers} from 'redux';
import Auth from '../reducers/auth';
import strapiRes from '../reducers/strapiRes';
import Profile from '../reducers/profile'

export default combineReducers({
  Auth,
  strapiRes,
  Profile
});
